import Box from "@amzn/meridian/esm/components/box";
import Column from "@amzn/meridian/esm/components/column";
import Text from "@amzn/meridian/esm/components/text";
import Theme from "@amzn/meridian/esm/components/theme";
import Thumbnail from "@amzn/meridian/esm/components/thumbnail";
import { THEME_COLOR } from "../../styles/colors";
import { AVATAR_SIZE, PROFILE_PHOTO_BASE } from "./whosWho.constants";

// Fallback when the person has no badge photo stored. Half the avatar size as the fill
// radius gives a full circle without the emotion helper class.
const InitialsAvatar = ({ initials }) => (
  <Theme tokens={{ boxBorderRadiusFill: AVATAR_SIZE / 2 }}>
    <Box
      type="fill"
      width={AVATAR_SIZE}
      height={AVATAR_SIZE}
      backgroundColor={THEME_COLOR.MIST_GRAY}
    >
      <Column height="100%" alignmentVertical="center" alignmentHorizontal="center">
        <Text type="h50" color="secondary">{initials || ""}</Text>
      </Column>
    </Box>
  </Theme>
);

/**
 * Circular avatar for an invitee: the person's badge photo, falling back to their initials when
 * there's no photo or the alias is missing. Thumbnail handles the circular masking, so a real
 * 404 shows Thumbnail's broken-image state rather than the initials fallback.
 *
 * @param {Object} params
 * @param {string} params.alias - Amazon alias; used to build the badge-photo URL.
 * @param {string} params.initials - Initials to show in the fallback avatar.
 * @param {boolean} params.hasPhoto - Whether a badge photo is expected to exist.
 */
const ProfilePhoto = ({ alias, initials, hasPhoto }) => {
  if (!alias || !hasPhoto) {
    return <InitialsAvatar initials={initials} />;
  }

  return (
    <Thumbnail
      type="circular"
      size="small"
      source={`${PROFILE_PHOTO_BASE}${alias}.jpg`}
      backgroundColor={THEME_COLOR.MIST_GRAY}
    />
  );
};

export default ProfilePhoto;
